export const BCSINFO = 'ALLBCAINFOFORTESTING';
export const SITEKEY = 'Site';
export const STATUSKEY = 'Status';
export const MISSINGVOLUMEKEY = 'MissingVolume';
